<template>
  <base-section id="about-us-detail">
  	<div 
    data-aos="fade-up"
    data-aos-delay="50"
    data-aos-duration="1000"
    data-aos-easing="ease-in-out"
    data-aos-mirror="true"
    data-aos-once="false"
    data-aos-anchor-placement="top-center">
    <base-section-heading
      color="grey lighten-2"
      title="Sejarah Asuransi Syariah Pertama Di Indonesia"
    />
    <v-container class="text-justify">
    <p><span style="font-weight: 400;">Keinginan membentuk asuransi syariah di Indonesia sebenarnya sudah muncul sejak lama sebelum berdirinya bank syariah pertama, Bank Muamalat. Tekad itu semakin kuat manakala Bank Muamalat sudah benar-benar resmi beroperasi pada tanggal 1 Mei 1992. Baru pada tanggal 27 Juli 1993, para wakil dari Yayasan Abdi Bangsa, Bank Muamalat Indonesia, dan Asuransi Jiwa Tugu Mandiri, sebagai sponsor Team Pembentukan Asuransi Takaful Indonesia (TEPATI), berkumpul guna mewujudkan harapan besar tersebut. Team ini juga mendapat dukungan dari beberapa pejabat Departemen Keuangan RI dan sejumlah pengusaha muslim Indonesia.</span></p>
    <p><span style="font-weight: 400;">&ldquo;Selain memudahkan koordinasi antara pemrakarsa dengan pemerintah, keterlibatan unsur Departemen Keuangan dimaksudkan agar sejak awal mereka memberikan perhatian kepada usaha besar ini,&rdquo; kata Rachmat Husen, Direktur Utama PT Syarikat Takaful Indonesia yang kala itu ditunjuk sebagai Ketua TEPATI.</span></p>
    <p><span style="font-weight: 400;">Sebagai langkah awal, 5 (lima) orang anggota TEPATI melakukan studi banding ke Malaysia dari tanggal 7 sampai 10 September 1993 dimana negara tersebut merupakan negara ASEAN pertama yang mempraktekkan asuransi syariah. Selama di Malaysia, seluruh anggota TEPATI berusaha melihat langsung dan mempelajari secara utuh prinsip-prinsip Takaful beserta penerapannya.</span></p>
    <p><span style="font-weight: 400;">Setelah melalui berbagai persiapan akhirnya didirikanlah PT Syarikat Takaful Indonesia (STI) pada tanggal 24 Februari 1994 sebagai bukti nyata dari sebuah komitmen dan kepedulian yang tulus terhadap perkembangan perekonomian berbasis syariah di lndonesia demi kemakmuran yang adil bagi masyarakat lndonesia secara keseluruhan. Selanjutnya, STI sebagai perusahaan induk (holding company) mendirikan 2 (dua) anak perusahaan yaitu PT Asuransi Takaful Keluarga dan PT Asuransi Takaful Umum.</span></p>
    <p><span style="font-weight: 400;">PT Asuransi Takaful Umum berdiri pada tanggal 14 Desember 1994 berdasarkan Akta Pendirian Nomor 46 tanggal 5 Mei 1994 dibuat dihadapan Notaris Lely Roostiati Yudo Paripurno, S.H., pada waktu itu pengganti Yudo Paripurno, S.H., Notaris di Jakarta dan telah  mendapat pengesahan dari Menteri Kehakiman Republik Indonesia dengan surat keputusannya Nomor C2-18.286.HT.01.01.TH.94 tanggal 14 Desember 1994. Peresmiannya sendiri dilakukan di Hotel Shangri-La Jakarta oleh Menristek/Ketua BPPT, BJ Habibie, yang kala itu juga merupakan pendiri sekaligus Ketua Ikatan Cendekiawan Muslim Indonesia (ICMI).</span></p>
    <p><span style="font-weight: 400;">Setelah melalui sejarah perjalanan panjangnya, akhirnya pada tahun 2018, Kospin (Koperasi Simpan Pinjam) Jasa dimana saat ini, komposisi kepemilikan sahamnya dipegang oleh Koperasi Simpan Pinjam JASA atau disingkat Kospin JASA (90,48%) dan Bahroji (9,52%).</span></p>
    <p style="text-align: justify;">
  Sebagai terobosan awal, pada acara Sosialisasi dan Pembagian Surplus Underwriting tanggal 13 September 2018, 
  Takaful Umum mengumumkan pembagian dana surplus underwriting tabarru’ kepada pihak-pihak yang berhak menerimanya 
  dengan jumlah total senilai Rp 3 miliar. Secara simbolis, dana tersebut diberikan kepada 3 (tiga) kategori penerima 
  terbesar yaitu PT Bank Muamalat Indonesia sebesar Rp 560 juta, PT Bank Syariah Mandiri sebesar Rp 487 juta, dan 
  BPRS Al-Salaam sebesar Rp 66 juta.

  <!-- Gambar di Tengah dengan Text Wrap -->
  <img src="../../../src/assets/ChartPie.jpg" width="500" 
       style="display: block; margin: 10px auto 10px; float: none; clear: both;">

          Pada kesempatan tersebut, Takaful Umum juga menyalurkan porsi surplus
          underwriting lainnya kepada beberapa lembaga sosial diantaranya
          Yayasan Amanah Takaful dan Dompet Dhuafa masing-masing senilai Rp 200
          juta.
        </p>

        <p>
          <span style="font-weight: 400;"
            >Sampai saat ini, Takaful Umum masih terus melakukan ekspansi pasar
            dan berhasil meningkatkan pendapatan kontribusi dari tahun ke tahun.
            Tantangan ke depan dihadapi dengan optimis melalui sejumlah program
            unggulan yang dibarengi dengan infrastruktur teknologi dan inovasi
            produk yang memadai dalam rangka mengantisipasi kemajuan
            perkembangan jaman yang ada.</span
          >
        </p>
      </v-container>
    </div>
    <div
      data-aos="zoom-in"
      data-aos-delay="50"
      data-aos-duration="1000"
      data-aos-easing="ease-in-out"
      data-aos-mirror="true"
      data-aos-once="false"
      data-aos-anchor-placement="top-center"
      class="grey lighten-4"
    >
      <v-container>
        <template>
          <base-section-heading title="Timeline Takaful Umum" />
            <img src="../../../src/assets/timeline.jpg" width="100%" 
                style="display: block; margin: 10px auto 10px; float: none; clear: both;">
          <!-- <v-timeline align-top :dense="$vuetify.breakpoint.smAndDown">
            <v-timeline-item
              v-for="(item, i) in items"
              :key="i"
              :color="item.color"
              :icon="item.icon"
              fill-dot
            >
              <v-card :color="item.color" dark outlined>
                <v-card-title class="title">{{ item.title }}</v-card-title>
                <v-card-text class="white text--primary body-2">
                  <p>{{ item.text }}</p>
                  <v-btn :color="item.color" class="mx-0" outlined>
                    {{ item.date }}
                  </v-btn>
                </v-card-text>
              </v-card>
            </v-timeline-item>
          </v-timeline> -->
        </template>
      </v-container>
    </div>
    <div
      data-aos="flip-down"
      data-aos-delay="50"
      data-aos-duration="1000"
      data-aos-easing="ease-in-out"
      data-aos-mirror="true"
      data-aos-once="false"
      data-aos-anchor-placement="top-center"
    >
      <base-section-heading
        color="grey lighten-2"
        title="Sejarah Logo dan Warna"
      />
      <v-container>
        <v-img
          :src="require('../../../src/assets/logohistory.jpg')"
          max-width="100%"
        />
        <base-title
          size="heading"
          space="4"
          title="MAKNA LOGO"
          class="fourth--text"
        />
        <base-body class="text-justify">
          Logo Takaful Umum berbentuk tulisan Arab تكافل bergaya kaligrafi
          modern yang melengkung seperti gelombang. Merepresentasikan
          fleksibilitas, adaptif, dan semangat untuk terus berkembang. Titik
          oranye pada tulisan arab memberi sentuhan energi dan semangat inovasi.
          Secara keseluruhan, bentuknya memadukan dua elemen yang berlawanan:
          Api dan Air. Api menggambarkan semangat, cahaya, dan energi kehidupan,
          sedangkan air melambangkan ketenangan, keberlanjutan, dan kekuatan.
          Kata “Takaful” berwarna biru tua melambangkan kepercayaan, stabilitas,
          keamanan, dan profesionalisme. Biru tua identik dengan industri
          keuangan dan asuransi karena memberi rasa aman. Kata “Umum” berwarna
          toska (teal) adalah gabungan biru (kepercayaan) dan hijau
          (syariah/kesucian). Memberi kesan modern, segar, inovatif, dan
          bernuansa islami namun tetap profesional. Menampilkan identitas
          syariah yang lebih kontemporer dan tidak kaku. "Sharia General
          Insurance" Menunjukan identitas industri perusahaan yang bergerak di
          bidang asuransi umum syariah..
        </base-body>
        <base-title
          size="heading"
          space="4"
          title="MAKNA WARNA"
          class="fourth--text"
        />
        <base-body class="text-justify">
          Terdapat 3 warna yang menjadi identitas Takaful, yaitu Biru, Turquoise
          dan Orange. Warna Biru melambangkan profesionalitas/keahlian dan
          stabilitas kinerja perusahaan, integritas dan ketekunan. Warna
          Turquoise melambangkan pertumbuhan keamanan dari asuransi. Sedangkan
          Orange melambangkan kejayaan
        </base-body>
        <v-tooltip bottom v-for="name in colour" :key="name">
          <template v-slot:activator="{ on, attrs }">
            <v-avatar
              v-bind="attrs"
              v-on="on"
              :color="name"
              class="ml-2"
              size="48"
            >
            </v-avatar>
          </template>
          {{ name }}
        </v-tooltip>
      </v-container>
    </div>
  </base-section>
</template>

<script>
export default {
  name: "SectionAboutUsDetail",

  data: () => ({
    colour: ["#001F48", "#008493", "#3EC2D1", "#FF6600"],
    items: [
      {
        color: "primary",
        icon: "mdi-star",
        title: "Syarikat Takaful Indonesia",
        text: "PT Syarikat Takaful lndonesia (Takaful lndonesia) didirikan",
        date: "24 Februari 1994"
      },
      {
        color: "secondary",
        icon: "mdi-book-variant",
        title: "Takaful Umum",
        text: "PT. Asuransi Takaful Umum didirikan",
        date: "14 Desember 1994"
      },
      {
        color: "accent",
        icon: "mdi-airballoon",
        title: "Takaful Umum Run Off",
        text:
          "PT. Asuransi Takaful Umum berhenti melakukan kegiatan penjualan dikarenakan pemegang saham STMB tidak melanjutkan",
        date: "9 November 2016"
      },
      {
        color: "fourth",
        icon: "mdi-cash-multiple",
        title: "Kospin Jasa",
        text: "Kospin Jasa mengakuisisi kepemilikkan Takaful Umum dari STMB",
        date: "Maret 2018"
      },
      {
        color: "primary",
        icon: "mdi-gift",
        title: "Underwriting Surplus",
        text:
          "Takaful Umum membagikan Underwriting Surplus dengan total 3 Miliar Rupiah kepada peserta",
        date: "13 September 2018"
      }
    ]
  })
};
</script>
